<template>
  <div class="contents-inner">
    <p
      class="text-block fwB pega-pre-wrap"
      data-test="catchCopy"
      v-text="description.catchCopy"
    />

    <p
      class="text-block pega-pre-wrap"
      data-test="detail"
      v-text="description.detail"
    />

    <template v-if="description.workflow">
      <h3
        class="hd-type-0n3"
        data-test="workflow-title"
      >
        <span>一日の仕事の流れ</span>
      </h3>
      <p
        class="mt20 pega-pre-wrap"
        data-test="workflow-value"
        v-text="description.workflow"
      />
    </template>

    <h3
      v-if="isShow.attentions"
      data-test="attention-title"
      class="hd-type-0n3"
    >
      <span>仕事の魅力</span>
    </h3>
    <div class="point-contents">
      <template v-for="(attention, key) in attentionsNotEmpty">
        <div
          :key="`${key}-title`"
          class="mt20 mb20"
        >
          <span class="point fs10">POINT<span class="fs16" /></span>
          <strong
            class="pl10"
            :data-test="`${key}-title`"
          >{{ attention.title }}</strong>
        </div>
        <p
          :key="`${key}-text`"
          :data-test="`${key}-text`"
          class="pega-pre-wrap"
          v-text="attention.text"
        />
      </template>
    </div>

    <template v-if="isShow.improved">
      <h3
        class="hd-type-0n3"
        data-test="improved-title"
      >
        <span>この仕事で磨ける経験・能力</span>
      </h3>
      <p
        class="mt20 pega-pre-wrap"
        data-test="improved-value"
        v-text="description.improved"
      />
    </template>

    <h3
      v-if="isShow.strengths"
      class="hd-type-0n3"
      data-test="strengths-title"
    >
      <span>アピールポイント</span>
    </h3>
    <div class="mt15">
      <template v-for="(value, key) in strengthsNotEmpty">
        <span
          :key="`${key}-title`"
          :data-test="`${key}-title`"
          class="apoint"
        >{{ strengthTitle[key] }}</span>
        <p
          :key="`${key}-value`"
          :data-test="`${key}-value`"
          class="mt15 mb15 pega-pre-wrap"
          v-text="value"
        />
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    description: {
      type: Object,
      required: true
    }
  }
}
</script>
